import * as React from "react";

interface Props {
    rowSpan: number;
    date: Date;
    left?: number;
    className?: string;
}

const TDate = ({ rowSpan, date, left, className }: Props) => {

    // If you change the timezone on your local computer, it should still show CWE times
    // a day should start at 00:00:00 (UTC 23:00 or 22:00 DST)

    //This logic is also in app.tsx getCweTimeForDisplayPurposes(date);
    var localCweDate = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Brussels' }));

    return <td rowSpan={rowSpan} className={(left ? "fixedColumn" : "") + " " + className} style={{ whiteSpace: "nowrap", left: left + "px" }}>
        {localCweDate.getFullYear() + "-" + ("0" + (localCweDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (localCweDate.getDate())).slice(-2)}
    </td>;
}
export default TDate;